/**
 * Bethel Bible Church brand palette - the single source of truth for color.
 *
 * theme.js builds the MUI theme from these values, and constants.js
 * re-exports the ones still used by direct import under their legacy
 * names. New code should import from here (or read colors off the MUI
 * theme via useTheme()/theme.palette) rather than hardcoding hex values.
 *
 * Core identity - these six colors carry roughly 90% of the site:
 *   Bethel Blue, Reformed Navy, Parchment, Linen, Charcoal, Sage.
 *
 * Oxblood and Brass are heritage/warm accents used deliberately
 * sparingly (sermon series graphics, Scripture quotes, seasonal
 * materials) - they are not meant to become a third and fourth "main"
 * site color. See CLAUDE.md for the full usage guide.
 *
 * The temporary Ezra Conference and Coffee Tournament pages intentionally
 * keep their own separate palettes and don't draw from this file.
 */

// Primary (blue) scale
export const BETHEL_BLUE = '#007CBB'; // primary.main - links, buttons, active states, brand recognition
export const REFORMED_NAVY = '#16324A'; // primary.dark - headers, footer, hero sections, serious backgrounds
export const SKY_BLUE = '#38A2C9'; // primary.light - highlights, illustrations, hover states
export const PALE_BLUE_MIST = '#CBDAE2'; // light section backgrounds, cards

// Warm neutrals
export const PARCHMENT = '#E8E3D6'; // secondary.main - existing tan, core secondary brand color
export const LINEN = '#F2EFE8'; // main alternate page background
export const SOFT_WHITE = '#FAFAF8'; // background.default/paper - cleaner replacement for pure white

// Text
export const CHARCOAL = '#32373C'; // text.primary - body text
export const INK = '#20282E'; // headlines where more weight is needed
export const STONE_GRAY = '#666667'; // text.secondary - muted/supporting text

// Structure
export const WARM_STONE = '#DED8D0'; // borders, dividers, cards

// Secondary / heritage / warm accents - use sparingly, see CLAUDE.md
export const OLIVE_SAGE = '#687864'; // ministry categories, subtle graphics, calmer accents
export const OXBLOOD = '#773E42'; // very sparingly: quotes, theological series, seasonal elements
export const BRASS = '#B08A56'; // tiny accents, icons, decorative rules

// Status
export const MUTED_GREEN = '#27805B'; // success states / giving confirmations
export const WARM_TERRACOTTA = '#C8674F'; // warnings/alerts, without screaming bright red

export const BETHEL_BLUE_RGB = `${parseInt(BETHEL_BLUE.slice(1, 3), 16)}, ${parseInt(BETHEL_BLUE.slice(3, 5), 16)}, ${parseInt(BETHEL_BLUE.slice(5), 16)}`;
